

import { Link } from '@mui/material';
import { RouterLink } from '../../routes/components';

// ----------------------------------------------------------------------

const Logo = ()=> {
 
  return (
    <Link component={RouterLink} href="/" sx={{ marginLeft:"30px", marginTop:"14px" }}  >
      {/*<img src='https://dealkarts.in/images/navlogo.png' width="60px" height='60px' />*/}
      <img src='.\assets\OES_LOGO.PNG' width="60px" height='60px' style={{borderRadius:'10%', marginTop:'10px'}} />
    </Link>
  );
};

export default Logo;
